import { Template, TemplateProps } from "./types";
import { getComputedColors, extractStyleValues } from "./utils";

export const listTemplate: Template = {
  id: "list",
  name: "List Layout",
  icon: "fa-solid fa-list",
  description: "Full-width list with horizontal layout",

  generateLayoutCSS(componentId: string): string {
    const selector = `#${componentId}[data-template="list"]`;
    
    return `
      /* List Layout - Full width items */
      ${selector} #job-items-wrapper:has(.job-item) {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    `;
  },

  generateStylingCSS(componentId: string, props: TemplateProps): string {
    const selector = `#${componentId}[data-template="list"]`;
    const styles = extractStyleValues(props);
    const buttonColors = getComputedColors(styles.buttonBackgroundColor);
    const captionColors = getComputedColors(styles.captionBackgroundColor);
    
    return `
      ${selector} .job-item {
        background-color: ${styles.cardBackgroundColor};
        border-radius: ${styles.cardBorderRadius}!important;
      }

      ${selector} .job-item-caption {
        background-color: ${captionColors.bgColor};
        color: ${captionColors.labelColor};
        border-radius: ${styles.captionBorderRadius};
      }

      ${selector} .job-item-heading {
        color: ${styles.headingColor};
      }

      ${selector} .job-item-link {
        background-color: ${buttonColors.bgColor};
        border-color: ${buttonColors.bgColor};
        color: ${buttonColors.labelColor};
        border-radius: ${styles.buttonBorderRadius};
      }

      ${selector} .job-item-link:hover {
        background-color: ${buttonColors.bgHoverColor};
      }
    `;
  },
};

